import { render, staticRenderFns } from "./ListDeliveryZonesView.vue?vue&type=template&id=7c13802a"
import script from "./ListDeliveryZonesView.vue?vue&type=script&lang=js"
export * from "./ListDeliveryZonesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports